import type { CustomerGroupType } from '@navio/nsdk';
import { type FilterOption } from 'noddi-ui-web';
import { CUSTOMER_GROUP_TYPE_OPTIONS, getUserGroupTypeIcon } from 'noddi-util';

export const CUSTOMER_GROUP_TYPE_FILTER_OPTIONS: FilterOption<CustomerGroupType>[] = CUSTOMER_GROUP_TYPE_OPTIONS.map(
  (opt) => ({
    ...opt,
    icon: getUserGroupTypeIcon(opt.value)
  })
);
